// extracted by mini-css-extract-plugin
export default {"loader":"LoadingScreen_loader__wri+t","pulse":"LoadingScreen_pulse__F5rZs","loaderWrapper":"LoadingScreen_loaderWrapper__WMRMi"};